import React, { Component } from "react";
import Mailto from './common/mailTo';

export class NewAccountLocked extends Component {

    constructor(props) {
        super(props);
     }

     render() {
          return (
              <div>
                  <div className="content">
                      <div className="main-content centered-content static-page">
                          <div className="container-sm login-container">
                              <div className="content-container">
                                  <div className="container-header">
                                      <h1>Success!</h1>
                                  </div>
                                  <div className="container-content">
                                      <span className="header-subheader">
                                          Your account has been created. Please allow 24 hours to be reviewed and activated.
                                      </span>                                          
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          );
     }
}